import {
  CARD_DIGITS_ONLY_REGEX,
  validateLuhn,
} from 'shared/utils/string/cardNumber';
import { z } from 'zod';

export const debitCardNumberValidationMessages = {
  required: 'Required',
  invalid: 'Invalid card number',
  invalid_number_of_digits: 'Debit card number must be 16 digits',
  invalid_only_digits: 'Debit card number must contain only digits',
};

const normalizeDebitCardNumber = (value: string): string =>
  value.replace(/\s/g, '');

export const debitCardNumberSchema = z
  .string({ error: debitCardNumberValidationMessages.required })
  .trim()
  .min(1, {
    error: debitCardNumberValidationMessages.required,
  })
  .transform(normalizeDebitCardNumber)
  .superRefine((value, ctx) => {
    if (!CARD_DIGITS_ONLY_REGEX.test(value)) {
      ctx.addIssue({
        code: 'custom',
        message: debitCardNumberValidationMessages.invalid_only_digits,
      });
      return;
    }

    if (value.length !== 16) {
      ctx.addIssue({
        code: 'custom',
        message: debitCardNumberValidationMessages.invalid_number_of_digits,
      });
      return;
    }

    if (!validateLuhn(value)) {
      ctx.addIssue({
        code: 'custom',
        message: debitCardNumberValidationMessages.invalid,
      });
    }
  });
